module.exports = __webpack_public_path__ + "static/img/581617348766.f3acdb2f.jpg";